import ModuleMixin from '@/Mixins/ModuleMixin'

export default {
    mixins: [
        ModuleMixin
    ],

    data() {
        return {
            name: 'module.postcode'
        }
    }
}